import React from 'react';
import '../style/signup.css'; 
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import imageuploadplaceholder from '../assets/imageuploadplaceholder.png';

const SellerProfile = () => {
  const uploadPhoto = () => {
    alert("Upload photo feature will be added here.");
  };

  return (
   <div className='uploadphoto signup'>
        <Container>
            <Row>
                <Col md={12}>
 <div >
          
      <h2 className='title'>
        Customize Your <br></br><em className='fw-semibold'>Seller</em> Profile
      </h2>
      <p className='subtitle'>
        Add info about your business, photos, lists and more to tell the story
      </p>

      <div className='profileImageWrapper'>
        <img
          src={imageuploadplaceholder}
          alt="Seller Profile"
          className='profileImage'
        />
        {/* <div className='uploadIcon' onClick={uploadPhoto}>
          <svg fill="#000000" viewBox="0 0 24 24" width="40" height="40">
            <path d="M15 14c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm-3 2c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4zm3.9-11.9c-.6-.6-1.4-.6-2 0l-1 1-1-1c-.6-.6-1.4-.6-2 0s-.6 1.4 0 2l1 1-1 1c-.6.6-.6 1.4 0 2s1.4.6 2 0l1-1 1 1c.6.6 1.4.6 2 0s.6-1.4 0-2l-1-1 1-1c.6-.6.6-1.4 0-2z" />
          </svg>
        </div> */}
      </div>
      <Button href='/Thankyou' type="submit" className='nextButton nextsteps  btn-submit'>Next Step</Button>
    </div>
    </Col>
      </Row>
        </Container>
        </div>
  );
};

export default SellerProfile;
